import React from 'react';
import type { CFEvent } from '@types';
import { Collapse } from '@components/Collapse';
import Textarea from '@components/Textarea';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import { useCustomFeature } from '../CustomFeatureContext';

function CEventSetting() {
  const { data, setData } = useCustomFeature<CFEvent>();
  const handlers = useTextareaHandelrs('trimRight', (val) =>
    setData((draft) => {
      draft.scriptStr = val;
    })
  );

  return (
    <Collapse title="事件设置">
      <Textarea
        scheme="dark"
        className="h-115"
        placeholder="非必填，将使用eval()执行的JavaScript代码"
        maxLength={10000}
        value={data.scriptStr}
        {...handlers}
      />
      <div className="mt-10 text-sm text-orange">
        <p>
          注：该功能支持具有开发能力的人员通过接入720漫游播放器SDK或在作品离线包中二次开发以实现点击按钮执行自定义的回调事件或操作。
        </p>
        <p>该设置在720云平台播放页点击无效。</p>
      </div>
    </Collapse>
  );
}

export default CEventSetting;
